import { useEffect } from 'react';
import moment from 'moment';

export function buildOccTicker(item) {
    if (!item?.symbol || !item?.expire_at || item.strike == null || !item.option_kind) {
        return null;
    }
    const expiration = moment(item.expire_at).utcOffset('+00:00').format('YYMMDD');
    const kind = String(item.option_kind).toUpperCase() === 'CALL' ? 'C' : 'P';
    const strike = Number(item.strike) * 1000;
    if (!Number.isFinite(strike)) {
        return null;
    }
    return `O:${String(item.symbol).toUpperCase()}${expiration}${kind}${strike.toFixed(0).padStart(8, '0')}`;
}

function collectOptionLegs(list, acc = []) {
    (list || []).forEach((item) => {
        const sub = Array.isArray(item?.sub_order) ? item.sub_order : [];
        if (sub.length) {
            collectOptionLegs(sub, acc);
            return;
        }
        if (item?.option_kind && item?.strike != null) {
            acc.push(item);
        }
    });
    return acc;
}

export default function useOptionQuotes(list, user_id, token, loadOptionQuotes) {
    const legs = collectOptionLegs(list);
    const tickersKey = [...new Set(legs.map(buildOccTicker).filter(Boolean))].sort().join(',');

    useEffect(() => {
        if (!tickersKey || !user_id || !loadOptionQuotes) {
            return undefined;
        }

        const tickers = tickersKey.split(',').filter(Boolean);
        loadOptionQuotes(tickers, user_id, token);

        const interval = setInterval(() => {
            loadOptionQuotes(tickers, user_id, token);
        }, 60000);

        return () => clearInterval(interval);
    }, [tickersKey, user_id, token, loadOptionQuotes]);
}
